/**
 * Số thuế phải nộp trên tờ khai thuế thu nhập doanh nghiệp điều chỉnh tăng/giảm:
 * NHANH3 08.04.2024
 */
export default {
  TNDNBusiness: 1052,
  TNDNProperty: 1053,
  TNDNTransfer: 1055,
  TNDNOil: 1056,
  TNDNLottery: 1057,
  TNDNOther: 1099,
};
